import actionTypes from './index';

export default () => ({
  type: actionTypes.CLEAR_VALIDATION,
});
